<template>
    <!-- Header -->
    <DxToolbar style="height: 56px" class="toolbar">
        <DxItem location="before" locate-in-menu="never">
            <template #default>
                <routerVue :breadcrumbsItems="breadcrumbsItems" />
            </template>
        </DxItem>
    </DxToolbar>
    <!-- Content -->

    <div class="row pl-4">
        <div class="xs12">
            <DxDataGrid
                id="gridContainer"
                class="table-page"
                :remote-operations="true"
                :show-borders="true"
                :data-source="DanhSachTheKiemSoat"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-row-lines="true"
                ref="DanhSachTheKiemSoat"
                :toolbar="{ visible: false }"
                :loadPanel="{ showIndicator: false, showPane: false, text: '' }"
                no-data-text="Không có dữ liệu!"
                height="calc(100vh - 56px)"
                @cellHoverChanged="onCellHoverChanged"
                @selection-changed="onSelectionChanged"
                :onEditorPreparing="onEditorPreparing"
                :onToolbarPreparing="onToolbarPreparing"
                :groupPanel="{ visible: 'auto' }"
                :stateStoring="{
                    enabled: true,
                    savingTimeout: 0,
                    storageKey: 'DanhSachTheKiemSoat',
                    type: 'localStorage',
                }"
            >
                <DxHeaderFilter :visible="true" :allow-search="true" />
                <DxFilterRow :visible="true" applyFilter="onClick" />
                <DxPaging :page-size="50" />
                <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                <DxColumnFixing :enabled="true" />
                <DxSelection
                    select-all-mode="allPages"
                    show-check-boxes-mode="always"
                    mode="multiple"
                />
                <DxColumn
                    data-field="TenLoaiThe"
                    caption="Loại thẻ"
                    :fixed="true"
                    width="250px"
                />
                <DxColumn data-field="TenNhomThe" caption="Nhóm thẻ" />
                <DxColumn data-field="KyHieuThe" caption="Ký hiệu thẻ" />
                <DxColumn data-field="MaThe" caption="Mã thẻ" alignment="left" />
                <DxColumn
                    :width="200"
                    alignment="left"
                    data-field="TenTrangThai"
                    caption="Trạng thái"
                    :fixed="true"
                    fixedPosition="right"
                    cell-template="statusTemplate"
                />
                <template #statusTemplate="{ data }">
                    <span :style="{ color: data.data.MaMauTrangThai }">
                        {{ data.data.TenTrangThai }}
                    </span>
                </template>
                <DxSummary>
                    <DxTotalItem
                        column="HoTen"
                        summary-type="count"
                        display-format="Tổng: {0}"
                        :show-in-group-footer="true"
                        :align-by-column="true"
                    />
                </DxSummary>
                <!-- Hover button -->
                <DxColumn
                    cssClass="column-button-hover"
                    data-field="Detail"
                    caption="Trạng thái"
                    width="1"
                    cell-template="buttons-cell"
                    :fixed="true"
                    fixedPosition="right"
                ></DxColumn>
                <template #buttons-cell="{ data }">
                    <div class="buttons">
                        <DxButton
                            class="mx-1"
                            type="default"
                            stylingMode="text"
                            icon="mdi mdi-pencil"
                            @click="SuaTheKiemSoat(data.data)"
                            hint="Sửa thẻ"
                        ></DxButton>
                        <DxButton
                            v-if="data.data.IdTrangThai != $t('TrangThaiThe.DaKhoa')"
                            class="mx-1"
                            type="danger"
                            stylingMode="text"
                            icon="mdi mdi-lock"
                            @click="KhoaTheKiemSoat(data.data)"
                            hint="Khóa thẻ"
                        ></DxButton>
                        <DxButton
                            v-if="data.data.IdTrangThai == $t('TrangThaiThe.DaKhoa')"
                            class="mx-1"
                            type="success"
                            stylingMode="text"
                            icon="mdi mdi-lock-open-outline"
                            @click="MoKhoaTheKiemSoat(data.data)"
                            hint="Mở khóa thẻ"
                        ></DxButton>
                        <DxButton
                            class="mx-1"
                            type="danger"
                            stylingMode="text"
                            icon="mdi mdi-credit-card-remove-outline"
                            @click="HuyCapThe(data.data)"
                            hint="Hủy cấp thẻ"
                        ></DxButton>
                        <DxButton
                            v-if="data.data.IdTrangThai != $t('TrangThaiThe.DaXoa')"
                            class="mx-1"
                            type="danger"
                            stylingMode="text"
                            icon="mdi mdi-delete"
                            @click="XoaTheKiemSoat(data.data)"
                            hint="Xóa thẻ"
                        ></DxButton>
                    </div>
                </template>

                <DxToolbarGrid>
                    <DxItemGrid location="after" name="groupPanel" />
                    <DxItemGrid location="before" template="listButtonTemplate" />
                    <DxItemGrid location="before" name="applyFilterButton" />
                    <DxItemGrid location="before" name="columnChooserButton" />
                    <DxItemGrid location="before" template="refreshTemplate" />
                </DxToolbarGrid>
                <template #listButtonTemplate>
                    <div class="row align-center">
                        <DxButton
                            type="normal"
                            icon="mdi mdi-reload"
                            styling-mode="contained"
                            hint="Tải lại"
                            class="mx-1"
                            @click="TaiLai"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-plus-circle"
                            styling-mode="contained"
                            class="mx-1"
                            @click="TaoMoiTheKiemSoat"
                            hint="Tạo mới"
                        />

                        <DxButton
                            :disabled="arrSelected.length != 1"
                            class="mx-1"
                            type="default"
                            stylingMode="text"
                            icon="mdi mdi-pencil"
                            @click="SuaTheKiemSoat(arrSelected[0])"
                            hint="Sửa thẻ"
                        ></DxButton>
                        <!-- <DxButton
                            :disabled="
                                arrSelected.length != 1 ||
                                (arrSelected.length > 0 &&
                                    arrSelected[0].IdTrangThai ==
                                        $t('TrangThaiThe.DaKhoa'))
                            "
                            class="mx-1"
                            type="danger"
                            stylingMode="text"
                            icon="mdi mdi-lock"
                            @click="KhoaTheKiemSoat(arrSelected[0])"
                            hint="Khóa thẻ"
                        ></DxButton>
                        <DxButton
                            :disabled="
                                arrSelected.length != 1 ||
                                (arrSelected.length > 0 &&
                                    arrSelected[0].IdTrangThai !=
                                        $t('TrangThaiThe.DaKhoa'))
                            "
                            class="mx-1"
                            type="success"
                            stylingMode="text"
                            icon="mdi mdi-lock-open-outline"
                            @click="MoKhoaTheKiemSoat(arrSelected[0])"
                            hint="Mở khóa thẻ"
                        ></DxButton> -->
                        <DxButton
                            :disabled="
                                arrSelected.length != 1 ||
                                (arrSelected.length > 0 &&
                                    arrSelected[0].IdTrangThai ==
                                        $t('TrangThaiThe.DaXoa'))
                            "
                            class="mx-1"
                            type="danger"
                            stylingMode="text"
                            icon="mdi mdi-delete"
                            @click="XoaTheKiemSoat(arrSelected[0])"
                            hint="Xóa thẻ"
                        ></DxButton>

                        <DxButton
                            type="normal"
                            icon="mdi mdi-file-excel"
                            styling-mode="contained"
                            class="mx-1"
                            hint="Xuất Excel"
                            @click="exportExcel"
                        />
                        <div
                            class="ml-2"
                            style="width: 1px; height: 24px; background: #03a9f4"
                        ></div>
                    </div>
                </template>
                <template #refreshTemplate>
                    <div class="row">
                        <DxButton
                            type="default"
                            styling-mode="text"
                            icon="mdi mdi-refresh"
                            hint="Khôi phục cài đặt gốc của bảng"
                            @click="onStateResetClick()"
                        />
                    </div>
                </template>
            </DxDataGrid>
        </div>
    </div>

    <DxPopup
        v-if="ifPopupXacNhan"
        v-model:visible="PopupXacNhan"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-close-button="false"
        :show-title="false"
        :width="488"
        height="auto"
        @hidden="onHidden('PopupXacNhan')"
    >
        <PopupXacNhan :Params="ParamXacNhan" @click="XacNhan" />
    </DxPopup>

    <DxPopup
        v-if="ifPopupThongTinTheKiemSoat"
        v-model:visible="PopupThongTinTheKiemSoat"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        width="1080px"
        height="auto"
        @hidden="onHidden('PopupThongTinTheKiemSoat')"
    >
        <PopupThongTinTheKiemSoatVue @hiddenPopup="hiddenPopup" @getData="getData" />
    </DxPopup>

    <DxPopup
        v-if="ifPopupSuaThongTinTheKiemSoat"
        v-model:visible="PopupSuaThongTinTheKiemSoat"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        width="488px"
        height="auto"
        @hidden="onHidden('PopupSuaThongTinTheKiemSoat')"
    >
        <PopupSuaThongTinTheKiemSoatVue @hiddenPopup="hiddenPopup" @getData="getData" />
    </DxPopup>

    <DxPopup
        v-if="ifPopupHuyCapTheChoNhanVien"
        v-model:visible="PopupHuyCapTheChoNhanVien"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        width="488px"
        height="auto"
        @hidden="onHidden('PopupHuyCapTheChoNhanVien')"
    >
        <PopupHuyCapTheChoNhanVienVue @hiddenPopup="hiddenPopup" @getData="getData" />
    </DxPopup>
</template>

<script>
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import routerVue from "@sonphat/common-v1/components/router.vue";
import { DxButton, DxPopup } from "devextreme-vue";
import { mapActions, mapState } from "vuex";
import PopupXacNhan from "@sonphat/common-v1/components/PopupXacNhan.vue";
import {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxHeaderFilter,
    DxSummary,
    DxPaging,
    DxTotalItem,
    DxColumnFixing,
    DxScrolling,
    DxToolbar as DxToolbarGrid,
    DxItem as DxItemGrid,
} from "devextreme-vue/data-grid";
import PopupThongTinTheKiemSoatVue from "./components/PopupThongTinTheKiemSoat.vue";
import PopupSuaThongTinTheKiemSoatVue from "./components/PopupSuaThongTinTheKiemSoat.vue";
import PopupHuyCapTheChoNhanVienVue from "../Nhan-Vien/components/PopupHuyCapTheChoNhanVien.vue";
export default {
    components: {
        PopupHuyCapTheChoNhanVienVue,
        PopupThongTinTheKiemSoatVue,
        PopupSuaThongTinTheKiemSoatVue,
        DxToolbar,
        DxItem,
        routerVue,
        DxButton,
        DxDataGrid,
        DxColumn,
        PopupXacNhan,
        DxPopup,
        DxSelection,
        DxFilterRow,
        DxSummary,
        DxTotalItem,
        DxColumnFixing,
        DxScrolling,
        DxToolbarGrid,
        DxItemGrid,
        DxHeaderFilter,
        DxPaging,
    },
    data() {
        return {
            NgungHoatDong: false,
            itemDangChon: null,
            DanhSachTheKiemSoat: [],
            PopupXacNhan: false,
            ifPopupXacNhan: false,
            KeyPopupXacNhan: null,
            ParamXacNhan: {
                WidthTitle: "90%",
                Title: "Bạn có chắc chắn muốn xóa thẻ kiểm soát đang chọn?",
                btnLeft: "HỦY",
                btnRight: "ĐỒNG Ý",
            },
            arrSelected: [],
            breadcrumbsItems: [
                {
                    id: "breadcrums_DieuDo",
                    text: this.$t("stringRouter.QLTT"),
                    disabled: true,
                    to: "",
                },
                {
                    id: "breadcrums_DieuDo",
                    text: "Thẻ kiểm soát",
                    disabled: true,
                    to: "",
                },
            ],
            ifPopupThongTinTheKiemSoat: false,
            PopupThongTinTheKiemSoat: false,
            ifPopupSuaThongTinTheKiemSoat: false,
            PopupSuaThongTinTheKiemSoat: false,
            ifPopupHuyCapTheChoNhanVien: false,
            PopupHuyCapTheChoNhanVien: false,
        };
    },

    computed: {
        ...mapState({
            DanhSachTheKiemSoat: (state) => state.QuanLyTheKiemSoat.DanhSachTheKiemSoat,
        }),
    },
    created() {
        this.getData();
    },

    methods: {
        hiddenPopup(name) {
            this[name] = false;
        },
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        async getData() {
            this.$refs.DanhSachTheKiemSoat?.instance.clearFilter();
            this.$refs.DanhSachTheKiemSoat?.instance.clearSelection();
            try {
                this.DanhSachTheKiemSoat = (
                    await this.$store.dispatch("TheKiemSoat/LayDanhSachTheKiemSoat")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        TaiLai() {
            this.getData();
        },
        onEditorPreparing(e) {
            this.$Helper.Common.FilterRowWhenEnter(e);
        },
        onToolbarPreparing(e) {
            e.toolbarOptions.visible = true;
        },
        onStateResetClick() {
            this.$refs.DanhSachTheKiemSoat.instance.state(null);
            setTimeout(() => {
                this.$refs.DanhSachTheKiemSoat.instance.clearFilter();
                this.$refs.DanhSachTheKiemSoat.instance.clearSelection();
                this.$refs.DanhSachTheKiemSoat.instance.clearSorting();
            }, 100);
        },
        onCellHoverChanged(e) {
            this.$Helper.Common.table({ Element: e, Buttons: true }).HoverRow();
        },
        onSelectionChanged(e) {
            this.arrSelected = e.selectedRowsData;
        },
        TaoMoiTheKiemSoat() {
            this.$store.commit("TheKiemSoat/Reset_ThongTinTheKiemSoat");
            this.showPopup("PopupThongTinTheKiemSoat");
        },
        SuaTheKiemSoat(e) {
            this.$store.commit("TheKiemSoat/Set", {
                key: "ThongTinTheKiemSoat",
                data: this.$Helper.Common.CloneData(e),
            });
            this.showPopup("PopupSuaThongTinTheKiemSoat");
        },
        exportExcel() {
            let init = {
                Element: this.$refs.DanhSachTheKiemSoat.instance,
                FileName: "DanhSachTheKiemSoat",
                WorkSheet: "Danh Sách",
            };
            this.$Helper.Common.excel(init).Export();
        },

        XoaTheKiemSoat(data) {
            this.KeyPopupXacNhan = "XoaTheKiemSoat";
            this.ParamXacNhan.Title =
                "Bạn có chắc chắn muốn xóa thẻ kiểm soát đang chọn?";
            this.itemDangChon = data;
            this.showPopup("PopupXacNhan");
        },
        KhoaTheKiemSoat(data) {
            this.KeyPopupXacNhan = "KhoaTheKiemSoat";
            this.ParamXacNhan.Title =
                "Bạn có chắc chắn muốn khóa thẻ kiểm soát đang chọn?";
            this.$store.commit("TheKiemSoat/Set", {
                key: "ThongTinTheKiemSoat",
                data: this.$Helper.Common.CloneData(data),
            });
            this.showPopup("PopupXacNhan");
        },
        MoKhoaTheKiemSoat(data) {
            this.KeyPopupXacNhan = "MoKhoaTheKiemSoat";
            this.ParamXacNhan.Title =
                "Bạn có chắc chắn muốn mở khóa thẻ kiểm soát đang chọn?";
            this.$store.commit("TheKiemSoat/Set", {
                key: "ThongTinTheKiemSoat",
                data: this.$Helper.Common.CloneData(data),
            });
            this.showPopup("PopupXacNhan");
        },
        HuyCapThe(data) {
            this.$store.commit("CapThe/Set", {
                key: "ThongTinHuyCapThe",
                data: {
                    IdThe: data.IdThe,
                    IdNhanVien: null,
                    LyDo: null,
                },
            });
            this.showPopup("PopupHuyCapTheChoNhanVien");
        },
        async XacNhan(bool) {
            if (bool == true) {
                this.itemDangChon = null;
                this.PopupXacNhanXoa = false;
                if (this.KeyPopupXacNhan == "XoaTheKiemSoat") {
                    this.ThucHienXoaTheKiemSoat();
                }
                if (this.KeyPopupXacNhan == "KhoaTheKiemSoat") {
                    this.ThucHienKhoaTheKiemSoat();
                }
                if (this.KeyPopupXacNhan == "MoKhoaTheKiemSoat") {
                    this.ThucHienMoKhoaTheKiemSoat();
                }
            } else if (bool == false) {
                this.itemDangChon = null;
                this.PopupXacNhan = false;
            }
        },
        async ThucHienKhoaTheKiemSoat() {
            try {
                this.$startLoading;
                const rs = await this.$store.dispatch("TheKiemSoat/KhoaTheKiemSoat");
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Khóa thông tin thẻ kiểm soát thành công!"
                    );
                    this.getData();
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Khóa thông tin thẻ kiểm soát thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                this.$Helper.ThongBaoPopup({
                    message_title: "Khóa thông tin thẻ kiểm soát thất bại!",
                    message: "Lỗi hệ thống client",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async ThucHienMoKhoaTheKiemSoat() {
            try {
                this.$startLoading;
                const rs = await this.$store.dispatch("TheKiemSoat/MoKhoaTheKiemSoat");
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Mở khóa thông tin thẻ kiểm soát thành công!"
                    );
                    this.getData();
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Mở khóa thông tin thẻ kiểm soát thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                this.$Helper.ThongBaoPopup({
                    message_title: "Mở khóa thông tin thẻ kiểm soát thất bại!",
                    message: "Lỗi hệ thống client",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async ThucHienXoaTheKiemSoat() {
            try {
                this.$startLoading;
                const rs = await this.$store.dispatch(
                    "TheKiemSoat/XoaTheKiemSoat",
                    this.itemDangChon.IdThe
                );
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Xóa thông tin thẻ kiểm soát thành công!"
                    );
                    this.getData();
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Xóa thông tin thẻ kiểm soát thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                this.$Helper.ThongBaoPopup({
                    message_title: "Xóa thông tin thẻ kiểm soát thất bại!",
                    message: "Lỗi hệ thống client",
                });
            } finally {
                this.$stopLoading;
            }
        },
    },
};
</script>

<style scoped></style>
